"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Recipients/MappingTable.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _lodash = require('lodash');


var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);



var _importDraft = require('../importDraft');


















/* Add from CSV's step 1 (Rev 31 v2 · 4a): one row per CSV column with a
 * sample, where it goes and its status (Matched, New variable or Skipped).
 * The rows themselves are reviewed in step 2. */
const MappingTable = ({ columns, mapping, previewedMapping, statuses, check, allowVariables = true, onChange }) => {
  const change = (next) => onChange(_importDraft.withColumnMapping.call(void 0, mapping, next))
  const onChangeDestination = (column, destination) =>
    change(_importDraft.mappingFor.call(void 0, column, destination, column.VariableName))
  const onChangeVariable = (column, name) =>
    change(_importDraft.mappingFor.call(void 0, column, 'variable', name))

  // A column whose mapping changed since the last check has no status yet;
  // the others show the last check's (review R800-11).
  const isStale = check !== 'current'
  const isChanged = (column) => isStale && !_lodash.isEqual.call(void 0, 
    mapping.find(m => m.Column === column.Index),
    previewedMapping.find(m => m.Column === column.Index),
  )

  return (
    _react2.default.createElement('table', { className: "broadcast-mapping", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
      , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, "Column in file"  )
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}, "Sample")
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, "Import as" )
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, _react2.default.createElement('span', { className: "broadcast-visually-hidden", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Status"))
        )
      )
      , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
        ,  columns.map((column, i) => {
          const status = statuses[i]
          const m = mapping.find(x => x.Column === column.Index)
          const destination = _importDraft.destinationOf.call(void 0, m)
          return (
            _react2.default.createElement('tr', { key: column.Index, className: _classBuilder2.default.call(void 0, destination === 'ignore' && 'broadcast-mapping--row-ignored'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
              , _react2.default.createElement('th', { scope: "row", className: "broadcast-mapping--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}},  column.Header )
              , _react2.default.createElement('td', { className: "broadcast-mapping--sample", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
                ,  column.Samples.slice(0, 2).filter(Boolean).join(' \u00b7 ') 
              )
              , _react2.default.createElement('td', { className: "broadcast-mapping--import", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
                , _react2.default.createElement('select', {
                  'aria-label': `Map ${column.Header} to`,
                  className: _classBuilder2.default.call(void 0, 
                    'blm-simple-select broadcast-select--compact broadcast-mapping--select',
                    destination === 'ignore' && 'broadcast-mapping--select--ignore',
                  ),
                  value: destination,
                  onChange: e => onChangeDestination(column, e.target.value ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}

                  ,  _importDraft.PATIENT_FIELDS.map(p => (
                    _react2.default.createElement('option', { key: p.field, value: `patient:${p.field}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}, "Patient field: "  ,  p.label )
                  ))
                  ,  allowVariables && _react2.default.createElement('option', { value: "variable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, "Variable") 
                  , _react2.default.createElement('option', { value: "ignore", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}, "Don't import" )
                )
                ,  _optionalChain([m, 'optionalAccess', _ => _.Destination]) === 'variable' && (
                  _react2.default.createElement('span', { className: "broadcast-mapping--variable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
                    , _react2.default.createElement('span', { 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}},  '{{' )
                    , _react2.default.createElement('input', {
                      'aria-label': `Variable name for ${column.Header}`,
                      className: "broadcast-mapping--input",
                      value: m.Variable,
                      size: Math.max(m.Variable.length, 4),
                      maxLength: 64,
                      onChange: e => onChangeVariable(column, e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
                    )
                    , _react2.default.createElement('span', { 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}},  '}}' )
                  )
                )
              )
              , _react2.default.createElement('td', { className: _classBuilder2.default.call(void 0, 'broadcast-mapping--status', isStale && 'broadcast-mapping--status--stale'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
                ,  isChanged(column)
                  ? (
                      _react2.default.createElement('span', { className: "broadcast-mapping--pill broadcast-mapping--pill--ignore" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
                        ,  check === 'checking' ? 'Checking…' : 'Not checked' 
                      )
                    )
                  : status && (
                    _react2.default.createElement('span', { className: `broadcast-mapping--pill broadcast-mapping--pill--${status.tone}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}},  status.label )
                  )
                
              )
            )
          )
        })
      )
    )
  )
}

exports. default = MappingTable
